export default (price) => {
  const mainPartOfPrice = `${price}`.split('.')[0];
  const secondPartOfPrice = `${price}`.split('.')[1];
  let formattedPrice = '';
  let counter = 0;
  for (let i = mainPartOfPrice.length; i > 0; i--) {
    if (counter === 3) {
      formattedPrice = ` ${formattedPrice}`;
      counter = 0;
    }
    formattedPrice = mainPartOfPrice[i - 1] + formattedPrice;
    counter++;
  }
  if (!secondPartOfPrice) {
    return formattedPrice;
  }
  const shortSecondPart = `${secondPartOfPrice}`.slice(0, 2);
  formattedPrice += `.${shortSecondPart}`;

  return formattedPrice;
};
